export default function Competition({ translations }: { translations: any }) {
  return (
    <a
      href="https://www.createporn.com/blog/prompting-contest-jul-7"
      target="_blank"
      rel="noopener noreferrer"
      className="mb-4 flex cursor-pointer flex-col justify-center border-[0.5px] border-[#3C3C3C] bg-[#2B2D31] py-4 text-center text-sm shadow-sm sm:rounded-lg"
    >
      <div className="mx-auto font-bold text-[#FFCC18]">
        {translations.competition} 🏆 {translations.competitionName}
      </div>
      <div className="my-4 w-full border-t-[1px] border-[#3C3C3C]"></div>
      <div className="mx-auto flex flex-row font-medium text-white">
        <div className="mr-2">🥇 {translations.firstPlace}:</div>
        <div>150,000 {translations.gems}</div>
      </div>
      <div className="mx-auto mt-2 flex flex-row font-medium text-white">
        <div className="mr-2">🥈 {translations.secondPlace}:</div>
        <div>100,000 {translations.gems}</div>
      </div>
      <div className="mx-auto mt-2 flex flex-row font-medium text-white">
        <div className="mr-2">🥉 {translations.thirdPlace}:</div>
        <div>50,000 {translations.gems}</div>
      </div>
      <div className="mx-auto mt-2 flex flex-row font-medium text-white">
        <div className="mr-2">🎖️ {translations.participation}:</div>
        <div>10,000 {translations.gems}</div>
      </div>
      <div className="my-4 w-full border-t-[1px] border-[#3C3C3C]"></div>
      <div className="mx-auto font-semibold text-[#FFCC18]">{translations.learnMore}</div>
    </a>
  );
}
